import { useState } from "react";

import client1 from "@/assets/Clients/1-BWSSB.png";
import client2 from "@/assets/Clients/2-Qualitest.jpg";
import client3 from "@/assets/Clients/3-Infoshare.png";
import client4 from "@/assets/Clients/4-Qream.png";
import client5 from "@/assets/Clients/5-Valentic.jpg";
import client6 from "@/assets/Clients/6-Embitel.png";
import client7 from "@/assets/Clients/7-Cyient.png";
import client8 from "@/assets/Clients/8-coforge.svg";
import client9 from "@/assets/Clients/9-Datamatics.svg";
import client10 from "@/assets/Clients/10-Wissen.png";
import client11 from "@/assets/Clients/11-Mavi.png";
import client12 from "@/assets/Clients/12-Maments.png";
import client13 from "@/assets/Clients/13-Vilcart.png";
// import client14 from "@/assets/Clients/14";
// import client15 from "@/assets/Clients/15-Utopus.png";
// import client16 from "@/assets/Clients/16-Reflector.png";
import client17 from "@/assets/Clients/17-Prodevans.png";
import client18 from "@/assets/Clients/18-Intuceo.png";
import client19 from "@/assets/Clients/19-Vedmind.png";
import client20 from "@/assets/Clients/20-Knack.png";
import client21 from "@/assets/Clients/21-Citylink.svg";
import client22 from "@/assets/Clients/22-Kagina.webp";
import client23 from "@/assets/Clients/23-Kou-Chan.png";
import client24 from "@/assets/Clients/24-Visbymedical.jpg";
import client25 from "@/assets/Clients/25-Euronet.png";
import client26 from "@/assets/Clients/26-Supreme Logo.png";
import client27 from "@/assets/Clients/27-NimbleVision.png";
import client28 from "@/assets/Clients/28-keysustainability.png";
import client29 from "@/assets/Clients/29-Kyndrly.avif";
import client30 from "@/assets/Clients/30-Logica.png";
import client31 from "@/assets/Clients/31-Zucitech.png";

const TrustedClients = () => {
  const [isPaused, setIsPaused] = useState(false);

  const logos = [
    client1,
    client2,
    client3,
    client4,
    client5,
    client6,

    client11,
    client9,
    client10,
    client12,
    client13,

    client8,
    // client15,
    // client16,
    client17,
    client18,
    client19,
    client20,
    client21,
    client22,
    client23,
    client24,
    client25,
    client26,
    client7,
    client27,
    client28,
    client29,
    client30,
    client31,
  ];

  const duplicatedLogos = [...logos, ...logos];

  return (
    <section
      id="trusted-clients"
      className="relative py-12 overflow-hidden bg-gradient-to-r from-background via-primary/5 to-background dark:from-background dark:via-primary/10 dark:to-background"
    >
      <div className="container mx-auto px-4 text-center mb-8">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-bold bg-duo-gradient bg-clip-text text-transparent">
          Trusted by Leading Companies
        </h2>
        <p className="text-muted-foreground text-sm mt-2">
          Delivering enterprise solutions to global clients
        </p>
      </div>

      <div
        className="relative w-full overflow-hidden"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {/* Gradient fade edges */}
        <div className="absolute left-0 top-0 h-full w-20 bg-gradient-to-r from-background to-transparent z-10" />
        <div className="absolute right-0 top-0 h-full w-20 bg-gradient-to-l from-background to-transparent z-10" />

        <div
          className={`flex w-min gap-12 items-center animate-scroll ${
            isPaused ? "paused" : ""
          }`}
        >
          {duplicatedLogos.map((logo, index) => (
            <div
              key={index}
              className="flex items-center justify-center min-w-[120px] sm:min-w-[140px] md:min-w-[160px] grayscale-0 opacity-100 hover:grayscale-0 hover:opacity-100 hover:scale-110 transition duration-300"
            >
              <img
                src={logo}
                alt={`client-logo-${index}`}
                className="h-10 sm:h-12 md:h-14 md:w-36  object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedClients;
